import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { FusePageSimple, DemoContent, TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import Formsy from 'formsy-react';
import { Button, FormControlLabel, TextField, Hidden, MenuItem, Radio, Icon, Checkbox, Typography, IconButton } from 'material-ui';
import ReactTable from "react-table";
import axios from 'axios';
import { bindActionCreators } from 'redux';
import { Tab, Tabs } from 'material-ui';
import AddIcon from '@material-ui/icons/Add';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import $ from "jquery";
import Input, { InputLabel, InputAdornment } from 'material-ui/Input';
import { withAlert } from 'react-alert';
import Loader from "other-components/loader/loader";

const styles = theme => ({
    layoutRoot: {}
});

var id = null;
var nic = null;
var schoolName = null;
var indexNo = null;
var year = null;
var country = null;
var isActive = null;
var olGradeArray = [];
var olSubjectArray = [];
var inputsAddOGrades = [];
// var alSubjectArray = [];
var emp_profile_id = null;
var emp_registry_id = null;


class Tab4LoadEmployeeOlQualification extends Component {

    state = {
        canSubmit: false,
        // value :0
    };

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            data: []
        };
        this.loadData();


        this.state = {
            imageURL: 'assets/images/default-avatar.png',
            loading: true,
            inputsAddOGrade: ['1'],
            inputsAddOGrades: [],
            olGradeArray: [],
            olSubjectArray: [],
            value: '',
            grade: '',
            subject: ''
        };


    }


    // Edit Statement
    stateEdit = {
        canEdit: false
    };

    handleClickOpenEdit = () => {
        this.setState({ edit: true });
    };

    handleCloseEdit = () => {
        this.setState({ edit: false });
    };

    handleCloseSalary = () => {
        this.setState({ salary: false });
    };

    handleSearchAny = (e) => {
        // alert(e.target.value)
        this.setState({
            value: e.target.value
        });
        this.loadSearchData(e.target.value)
    }

    loadSearchData(searchValue) {

        const searchValueObj = {
            searchval: searchValue
        }
        var data = [];

        // axios.post('http://localhost:5002/hr/searchEmpOlQulification', searchValueObj)
        axios.post(window.hrmServer+'/hr/searchEmpOlQulification', searchValueObj)
            .then(response => {
                if (response.data.success) {
                    // alert('Success');
                    var empProfesionalQualificationObj = response.data.resultSearch;
                    // console.log("peeen "+employeeObj[31].PROFILE_IMAGE);

                    for (var i = 0; i < empProfesionalQualificationObj.length; i++) {

                        data.push({

                            nic: empProfesionalQualificationObj[i].NIC,
                            schoolName: empProfesionalQualificationObj[i].SCHOOL_NAME,
                            indexNo: empProfesionalQualificationObj[i].INDEX_NO,
                            year: empProfesionalQualificationObj[i].YEAR,
                            country: empProfesionalQualificationObj[i].COUNTRY,
                            emp_profile_id: empProfesionalQualificationObj[i].ID_EMPLOYEE_REGISTRY,
                            emp_registry_id: empProfesionalQualificationObj[i].ID_EMPLOYEE_PROFILE


                        });
                    }
                    this.setState({ data: data });
                    this.setState({ loading: false });
                }


            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });

        this.handleCloseEdit();
    }

    handleChangeSubject = (e) => {
        // alert(e.target.value)
        this.setState({ subject: e.target.value });
    }

    handleChangeGrade = (e) => {
        // alert(e.target.value)
        this.setState({ grade: e.target.value });
    }

    deleteOResult(grade, subject) {
        // alert(grade+""+subject)
        var arrayOGrade = this.state.olGradeArray // make a separate copy of the array
        // alert("-1- " + arrayOGrade)
        var index = arrayOGrade.indexOf(grade)
        // alert("-index- " + index)
        arrayOGrade.splice(index, 1);
        // alert(arrayGrade)

        var arrayOSubject = this.state.olSubjectArray // make a separate copy of the array
        // alert(e+"-- "+arrayGrade)
        var index = arrayOSubject.indexOf(subject)
        arrayOSubject.splice(index, 1);
        // alert("-2- " + arrayOGrade)

        var newInputAdd = `${this.state.inputsAddOGrade.length - 1}`

        this.setState({
            inputsAddOGrade: this.state.inputsAddOGrade.concat([newInputAdd]),
            olGradeArray: arrayOGrade,
            olSubjectArray: arrayOSubject

        });
        // alert("-3- "+this.state.olGradeArray)
        this.removeOGrade();
        // this.setState({ people: array });
    }

    removeOGrade() {

        inputsAddOGrades = [];
        this.setState({
            inputsAddOGrades: [],
        });
        // alert("-3- " + this.state.olGradeArray)

        for (let i = 0; i < this.state.olGradeArray.length; i++) {
            inputsAddOGrades.push(
                <div className="w-full">
                    <TextFieldFormsy
                        className="w-full md:w-1/3 mt-16 pr-24"
                        id={"oSubject" + i}
                        type="text"
                        name={"oSubject" + i}
                        label={"Subject"}
                        disabled={true}
                        value={this.state.olSubjectArray[i]}
                        validations={{
                            maxLength: 50
                        }}
                        validationErrors={{

                            maxLength: 'This is not a valid'
                        }}
                    />

                    <TextFieldFormsy
                        className="w-full md:w-1/3 mt-16 pr-24"
                        id={"oGreade" + i}
                        type="text"
                        name={"oGreade" + i}
                        label={"Greade"}
                        disabled={true}
                        value={this.state.olGradeArray[i]}
                        validations={{
                            maxLength: 50
                        }}
                        validationErrors={{

                            maxLength: 'This is not a valid'
                        }}
                    />


                    <IconButton style={{ marginLeft: 'auto', height: '38px' }}
                        title="Delete or Restore"
                        // className={classes.smaller}
                        onClick={(ev) => {
                            // ev.stopPropagation();
                            this.deleteOResult(this.state.olGradeArray[i], this.state.olSubjectArray[i])
                        }}

                    >
                        <Icon className="text-red-light">delete</Icon>
                    </IconButton>

                    {/* <div>
                        <Button type="button" variant="fab" mini color="secondary" onClick={() => this.appendInputOGrade()} aria-label="add">
                            <AddIcon />
                        </Button>
                    </div> */}

                </div>

            )
        }
        this.setState({
            inputsAddOGrades: inputsAddOGrades,
        });
    }


    appendInputOGrade() {

        var newInputAdd = `${this.state.inputsAddOGrade.length + 1}`;
        // alert(this.state.subject)
        // var valueOfLastAddGrade = $("#oGreade").val();
        // var valueOfLastAddSubject = $("#oSubject").val();

        var valueOfLastAddGrade = this.state.grade;
        var valueOfLastAddSubject = this.state.subject;
        // olGradeArray.push(valueOfLastAddGrade)
        // olSubjectArray.push(valueOfLastAddSubject)

        if ("" == valueOfLastAddGrade || null == valueOfLastAddGrade || undefined == valueOfLastAddGrade ||
            "" == valueOfLastAddSubject || null == valueOfLastAddSubject || undefined == valueOfLastAddSubject) {
            // alert("Input above Addition first !");
            this.props.alert.info("Add Subject And Grade First !");
        } else {
            // this.setState({
            //     inputsAddOGrade: this.state.inputsAddOGrade.concat([newInputAdd]),
            //     olGradeArray: olGradeArray,
            //     olSubjectArray: olSubjectArray
            // });
            this.appendInputOGrades(this.state.grade, this.state.subject)

            this.setState({
                grade: '',
                subject: ''
            });
        }
    }

    appendInputOGrades(a, b) {
        // alert(length+"vv"+a+"vv"+b)
        var newInputAdd = `${this.state.inputsAddOGrade.length + 1}`;



        olGradeArray.push(a)
        olSubjectArray.push(b)
        inputsAddOGrades.push(<div className="w-full">

            <TextFieldFormsy
                className="w-full md:w-1/3 mt-16 pr-24"
                id={"oSubject" + newInputAdd}
                type="text"
                name={"oSubject" + newInputAdd}
                label={"Subject"}
                value={b}
                disabled={true}
                validations={{
                    maxLength: 50
                }}
                validationErrors={{

                    maxLength: 'This is not a valid'
                }}
            />

            <TextFieldFormsy
                className="w-full md:w-1/3 mt-16 pr-24"
                id={"oGreade" + newInputAdd}
                type="text"
                name={"oGreade" + newInputAdd}
                label={"Greade"}
                value={a}
                disabled={true}
                validations={{
                    maxLength: 50
                }}
                validationErrors={{

                    maxLength: 'This is not a valid'
                }}
            />
            <IconButton style={{ marginLeft: 'auto', height: '38px' }}
                title="Delete or Restore"
                // className={classes.smaller}
                onClick={(ev) => {
                    // ev.stopPropagation();
                    this.deleteOResult(a, b)
                }}

            >
                <Icon className="text-red-light">delete</Icon>
            </IconButton>
        </div>)

        // alert(length + "vv" + a + "vv" + b)
        this.setState({
            inputsAddOGrade: this.state.inputsAddOGrade.concat([newInputAdd]),
            inputsAddOGrades: inputsAddOGrades,
            olGradeArray: olGradeArray,
            olSubjectArray: olSubjectArray

        });
        // alert(this.state.olSubjectArray.length)
        this.setState({ edit: true });


    }



    // load all emlployee personal data 
    loadData() {
        // axios.get('http://localhost:5002/hr/getEmployeeOlQulification')
        axios.get(window.hrmServer+'/hr/getEmployeeOlQulification')
            .then(response => {
                if (response.data.success) {
                    // alert('Success');
                    var employeeObj = response.data.rows;

                    this.appendToTable(employeeObj);
                }
            });

        this.handleCloseEdit();
    }


    // append data into table
    appendToTable(employeeObj) {
        var data = [];
        // console.log("peeen " + employeeObj[31].PROFILE_IMAGE);

        for (var i = 0; i < employeeObj.length; i++) {
            // alert(employeeObj[0].COUNTRY)
            // this.appendInputOGrades(employeeObj[i].COUNTRY, employeeObj[1].YEAR, employeeObj.length)

            data.push({

                nic: employeeObj[i].NIC,
                schoolName: employeeObj[i].SCHOOL_NAME,
                indexNo: employeeObj[i].INDEX_NO,
                year: employeeObj[i].YEAR,
                country: employeeObj[i].COUNTRY,
                emp_profile_id: employeeObj[i].ID_EMPLOYEE_REGISTRY,
                emp_registry_id: employeeObj[i].ID_EMPLOYEE_PROFILE


            });


        }
        this.setState({ data: data });
        this.setState({ loading: false });
    }

    loadOlDetails(nic) {
        // alert(nic)
        var loadEmpDetail = {
            searchVal: nic

        }

        // neeed to create edit employee persnol data servise
        // axios.post('http://localhost:5002/hr/loadEmployeeOlQualification', loadEmpDetail)
        axios.post(window.hrmServer+'/hr/loadEmployeeOlQualification', loadEmpDetail)
            .then(res => {

                // alert(res.data.success);
                if (res.data.success) {
                    // alert("Success");
                    olGradeArray = [];
                    olSubjectArray = [];
                    inputsAddOGrades = [];
                    for (var i = 0; i < res.data.result.length; i++) {
                        // alert(res.data.result[i].GRADE)
                        this.appendInputOGrades(res.data.result[i].GRADE, res.data.result[i].SUBJECT)
                    }


                } else {
                    // alert('Ivalid Credentials');
                }
            })
    }

    // edit persanol details function
    editEmployeeOlDetail(model) {
        var deleteObj = {
            employeeNic: model.nic
        }


        const employeeEducationDataObj = {
            nic: model.nic,
            emp_profile_id: model.emp_profile_id,
            emp_registry_id: model.emp_registry_id,
            oSchool: model.schoolName,
            oCountry: model.country,
            oYear: model.year,
            oIndexNo: model.indexNo,
            olGradeArray: olGradeArray,
            olSubjectArray: olSubjectArray

        }

        // axios.post('http://localhost:5002/hr/deleteEmployeeOlQualification', deleteObj)
        axios.post(window.hrmServer+'/hr/deleteEmployeeOlQualification', deleteObj)
            .then(response => {

                if (response.data.success) {
                    // alert('Success');
                    // axios.post('http://localhost:5002/hr/updateEmpOlQulification', employeeEducationDataObj)
                    axios.post(window.hrmServer+'/hr/updateEmpOlQulification', employeeEducationDataObj)
                        .then(response => {

                            if (response.data.success) {
                                // alert('Success');
                                this.handleCloseEdit();
                                this.loadData();
                                this.props.alert.success("Employee O/L Qulification Updated Successfully");
                                this.setState({ loading: false });
                            } else {
                                // alert("Delete Faild !");
                                this.props.alert.error("Error In Employee O/L Qulification Update");
                            }
                        }).catch(function (error) {
                            // alert("Error");
                            console.log("No internet connection or Internal error");
                            // alert("No internet connection or Internal error");
                        });

                } else {

                }
            }).catch(function (error) {
                // alert("Error");
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });


    }
    // Add Statement

    addhandleClickOpen = () => {
        this.setState({ add: true });
    };

    addhandleClose = () => {
        this.setState({ add: false });
    };

    disableButton = () => {
        this.setState({ canSubmit: false });
    };

    enableButton = () => {
        this.setState({ canSubmit: true });
    };

    // edit employee personal details
    onEdit = (model) => {

        this.editEmployeeOlDetail(model);
    };

    disableButtonDelete = () => {
        this.setState({ canEdit: false });
    };

    enableButtonDelete = () => {
        this.setState({ canEdit: true });
    };

    handleClickSalary = () => {
        // alert(e.value);
        this.setState({ salary: true });
    };


    // Delete Statement
    handleClickDelete = () => {
        // alert(e.value);
        this.setState({ delete: true });
    };

    handleCloseDelete = () => {
        this.setState({ delete: false });
    };

    stateDelete = {
        canDelete: false
    };

    onDelete = (model) => {
        this.deleteEmployeeOlDetail(model);
    };

    // delete emplpoyee o/l details
    deleteEmployeeOlDetail(model) {

        var employeeNic = model.nic;

        if (null == employeeNic || "" == employeeNic || undefined == employeeNic) {
            // alert("Cannot Delete this Employee");
        } else {

            var deleteObj = {
                employeeNic: employeeNic
            }

            // axios.post('http://localhost:5002/hr/deleteEmployeeOlQualification', deleteObj)
            axios.post(window.hrmServer+'/hr/deleteEmployeeOlQualification', deleteObj)
                .then(response => {

                    if (response.data.success) {
                        // alert('Success');
                        this.handleCloseDelete();
                        this.loadData();
                        this.props.alert.success("Employee O/L Qulification Deleted Successfully");
                    } else {
                        // alert("Delete Faild !");
                        this.props.alert.error("Error In Employee O/L Qulification Delete");
                    }
                }).catch(function (error) {
                    // alert("Error");
                    console.log("No internet connection or Internal error");
                    // alert("No internet connection or Internal error");
                });
        }
    }


    render() {
        const { classes, openEditContactDialog } = this.props;
        const { canSubmit } = this.state;
        const { canEdit } = this.stateEdit;
        const { canDelete } = this.stateDelete;
        const { value } = this.state;

        if (this.state.loading) {
            return (<Loader />);
        }
        else {
            return (

                <div className="w-full">
                    <div className="flex flex-wrap -mx-3 mb-12">
                        <div className="w-full md:w-2/3"></div>
                        <div className="w-full md:w-1/3">
                            {/* <Icon className="-mb-32 -mr-16" color="action">search</Icon> */}
                            <TextField
                                placeholder="Search for anything"
                                className="pl-16"
                                fullWidth
                                value={this.state.value}
                                inputProps={{
                                    'aria-label': 'Search'
                                }}
                                onChange={this.handleSearchAny}
                            />
                        </div>
                    </div>
                    <ReactTable className="w-full"
                        getTrProps={(state, rowInfo, column) => {
                            return {
                                className: "cursor-pointer",
                                onClick: (e, handleOriginal) => {

                                }
                            }
                        }}
                        data={this.state.data}
                        columns={[

                            {
                                Header: "Nic",
                                accessor: "nic",
                                // show: false
                            },
                            {
                                Header: "School Name",
                                accessor: "schoolName",
                                // show: false
                            },

                            {
                                Header: "Index No",
                                accessor: "indexNo",
                                // show: false
                            },
                            {
                                Header: "Year",
                                accessor: "year"

                            },
                            {
                                Header: "Country",
                                accessor: "country"

                            },



                            {
                                Header: "Action",
                                // accessor: "su",
                                width: 128,
                                Cell: row => (
                                    <div className="flex items-center w-8 h-8">
                                        <IconButton

                                            onClick={(e) => {
                                                if (row) {
                                                    // alert("this.state.olGradeArray")
                                                    schoolName = row.original.schoolName;
                                                    indexNo = row.original.indexNo;
                                                    nic = row.original.nic;
                                                    year = row.original.year;
                                                    country = row.original.country;
                                                    emp_profile_id = row.original.emp_profile_id;
                                                    emp_registry_id = row.original.emp_registry_id;
                                                    this.loadOlDetails(row.original.nic)
                                                    // title="Edit o/l details"

                                                }
                                            }}

                                        >
                                            <Icon className="text-blue">mode_edit</Icon>
                                        </IconButton>



                                        <Dialog

                                            open={this.state.edit}
                                            onClose={this.handleCloseEdit}
                                            aria-labelledby="form-dialog-title"
                                        >
                                            <Formsy
                                                onValidSubmit={this.onEdit}
                                                onValid={this.enableButtonEdit}
                                                onInvalid={this.disableButtonEdit}
                                                ref={(form) => this.form = form}
                                                className=""
                                            >
                                                <DialogTitle id="form-dialog-title">Edit O/L Qualification Details</DialogTitle>
                                                <DialogContent className="flex flex-wrap">

                                                    <div className="w-full">

                                                        <TextFieldFormsy
                                                            type="hidden"
                                                            name="id"
                                                        // value={id}
                                                        />
                                                        <TextFieldFormsy
                                                            type="hidden"
                                                            name="emp_profile_id"
                                                            value={emp_profile_id}
                                                        />
                                                        <TextFieldFormsy
                                                            type="hidden"
                                                            name="emp_registry_id"
                                                            value={emp_registry_id}
                                                        />

                                                        <TextFieldFormsy
                                                            className="w-1/3 pr-8"
                                                            type="text"
                                                            name="nic"
                                                            label="NIC No"
                                                            value={nic}
                                                            required
                                                            disabled={true}
                                                            id="nic"
                                                        />

                                                        <TextFieldFormsy
                                                            className="w-1/3 pr-8"
                                                            type="text"
                                                            name="indexNo"
                                                            label="indexNo"
                                                            value={indexNo}
                                                            disabled={true}

                                                        />

                                                        {/* <TextFieldFormsy
                                                        className="w-1/3"
                                                        type="text"
                                                        name="address2"
                                                        label="Address 2"
                                                    // value={address2}

                                                    /> */}

                                                    </div>

                                                    <div id="divAllowanceAdd" className="w-full md:w-1/2">

                                                        <div className="w-full">

                                                            <TextField
                                                                className="w-full md:w-2/3 mt-16 pr-24"
                                                                id="oSubject"
                                                                type="text"
                                                                name="oSubject"
                                                                label="Subject"
                                                                onChange={this.handleChangeSubject}
                                                                // value={this.state.olSubjectArray[inputAdd]}
                                                                value={this.state.subject}
                                                                validations={{
                                                                    maxLength: 50
                                                                }}
                                                                validationErrors={{

                                                                    maxLength: 'This is not a valid'
                                                                }}
                                                            />

                                                            <TextField
                                                                className="w-full md:w-1/3 mt-16 pr-24"
                                                                id="oGreade"
                                                                type="text"
                                                                name="oGreade"
                                                                label="Greade"
                                                                value={this.state.grade}
                                                                onChange={this.handleChangeGrade}
                                                                validations={{
                                                                    maxLength: 50
                                                                }}
                                                                validationErrors={{

                                                                    maxLength: 'This is not a valid'
                                                                }}
                                                            />
                                                        </div>
                                                        {this.state.inputsAddOGrades}
                                                    </div>
                                                    <Button type="button" variant="fab" mini color="secondary" onClick={() => this.appendInputOGrade()} aria-label="add" className="{classes.button} mt-24">
                                                        <AddIcon />
                                                    </Button>

                                                    <div className="w-full">
                                                        <TextFieldFormsy
                                                            className="w-full mt-16"
                                                            type="text"
                                                            name="schoolName"
                                                            label="School Name"
                                                            value={schoolName}
                                                        // onChange = {this.handleChange}
                                                        // required
                                                        // disabled={true}
                                                        />
                                                    </div>

                                                    <div className="w-full">
                                                        <TextFieldFormsy
                                                            className="w-1/2 pr-8 mt-16"
                                                            type="text"
                                                            name="year"
                                                            label="Year"
                                                            value={year}
                                                        // required
                                                        // disabled={true}
                                                        />

                                                        <TextFieldFormsy
                                                            className="w-1/2 mt-16"
                                                            type="text"
                                                            name="country"
                                                            label="Country"
                                                            value={country}

                                                        />
                                                    </div>

                                                    {/* <div className="w-full">
                                                    <TextFieldFormsy
                                                        className="w-1/2 pr-8 mt-16"
                                                        type="text"
                                                        name="telephone"
                                                        label="Telephone"
                                                    // value={telephone}
                                                    // disabled={true}
                                                    />

                                                    <TextFieldFormsy
                                                        className="w-1/2 mt-16"
                                                        type="text"
                                                        name="designation"
                                                        label="Designation"
                                                    // value={designation}
                                                    // disabled={true}
                                                    />
                                                </div> */}

                                                    {/* <div className="w-full">


                                                    <TextFieldFormsy
                                                        className="w-1/4 pr-8 mt-8"
                                                        type="text"
                                                        name="zipcode"
                                                        label="Zip Code"
                                                    // value={zipcode}
                                                    // disabled={true}
                                                    />

                                                    <TextFieldFormsy
                                                        className="w-1/4 pr-8 mt-8"
                                                        type="text"
                                                        name="countrycode"
                                                        label="Country Code"
                                                    // value={countrycode}
                                                    // disabled={true}
                                                    />
                                                </div> */}
                                                </DialogContent>
                                                <DialogActions>
                                                    <Button type="button" onClick={this.handleCloseEdit} variant="raised" size="small" color="primary" className="{classes.button} w-full  md:h-24">
                                                        Close
                                                </Button>

                                                    <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:h-24 ">
                                                        Update
                                                </Button>
                                                </DialogActions>
                                            </Formsy>
                                        </Dialog>




                                        <IconButton
                                            onClick={(e) => {
                                                if (row) {

                                                    nic = row.original.nic;
                                                    // deleteFirstName = row.original.firstName;
                                                    // deleteLastName = row.original.lastName;
                                                    this.setState({ delete: true });
                                                    // title="Do you want delete o/l details?"
                                                }
                                            }}
                                        >
                                            <Icon className="text-red-light">delete</Icon>
                                        </IconButton>


                                        {/* ///// */}

                                        <Dialog
                                            open={this.state.delete}
                                            onClose={this.handleClose}
                                            aria-labelledby="form-dialog-title"
                                        >
                                            <DialogTitle id="form-dialog-title">Delete O/L Qualification</DialogTitle>
                                            <DialogContent>

                                                <div>

                                                    <Formsy
                                                        onValidSubmit={this.onDelete}
                                                        onValid={this.enableButtonDelete}
                                                        onInvalid={this.disableButtonDelete}
                                                        ref={(form) => this.form = form}
                                                        className="flex flex-col justify-center"
                                                    >
                                                        <TextFieldFormsy
                                                            type="hidden"
                                                            name="nic"
                                                            value={nic}

                                                        />

                                                        <DialogActions>
                                                            <Button onClick={this.handleCloseDelete} color="primary">
                                                                Cancel
                                                                        </Button>

                                                            <Button
                                                                type="submit"
                                                                variant="raised"
                                                                color="primary"
                                                                className="mx-auto mt-16 pb-15"
                                                                aria-label="Edit"
                                                            // disabled={!canEdit}
                                                            >
                                                                Delete
                                                                        </Button>
                                                        </DialogActions>
                                                    </Formsy>
                                                </div>
                                            </DialogContent>


                                        </Dialog>




                                        {/* ///// */}


                                    </div>
                                )
                            }

                        ]}
                        defaultPageSize={10}
                        className="-striped -highlight"
                    />

                </div>
            );
        }
    }
}

export default withStyles(styles, { withTheme: true })(withAlert(Tab4LoadEmployeeOlQualification));


// WEBPACK FOOTER //
// ./src/main/content/hr/viewEmployee/components/Tab4LoadEmployeeOlQualification.js